export default __webpack_public_path__ + "static/media/lora_xl.fd2c89af.jpg";